import React from "react";
import "./Chips.css";

/* Category color is inferred from product name/brand text — same idea
   as UnitChip. The product title itself stays dark text regardless;
   only this small identifier avatar carries the category color. */
const PRODUCT_VARIANTS = [
  { test: /headphone|headset|earphone/i, family: "avatar-orange" },
  { test: /laptop|notebook/i, family: "avatar-blue" },
  { test: /battery|ups\b/i, family: "avatar-yellow" },
  { test: /printer|canon/i, family: "avatar-purple" },
];

function getProductVariant(haystack) {
  const match = PRODUCT_VARIANTS.find((entry) => entry.test.test(haystack));
  return match ? match.family : "avatar-neutral";
}

export default function ProductTypeAvatar({ name, brand, category }) {
  const haystack = [category, name, brand].filter(Boolean).join(" ");
  const family = getProductVariant(haystack);
  const letter = String(name || "P").trim().charAt(0).toUpperCase() || "P";

  return (
    <div className={`product-type-avatar ${family}`} aria-hidden="true">
      {letter}
    </div>
  );
}
